import { render, staticRenderFns } from "./tours_control_monitor.vue?vue&type=template&id=05b85bc3"
import script from "./tours_control_monitor.vue?vue&type=script&lang=js"
export * from "./tours_control_monitor.vue?vue&type=script&lang=js"
import style0 from "./tours_control_monitor.vue?vue&type=style&index=0&id=05b85bc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports